// extracted by mini-css-extract-plugin
export default {"mainSection":"Main_mainSection__cv5AU","main-menu__item":"Main_main-menu__item__zjvmt","mainWrapper":"Main_mainWrapper__OrjyZ","mainWrapper__info":"Main_mainWrapper__info__ME-w9"};